"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSpacingToPixels = void 0;
/**
 * Convert a string to it's old SIZES values in rem
 * @param value ie: "0.25", "2", "1.5", "2 4", "2 4 6 8"
 * @returns "0.125rem", "1rem", "0.75rem", "1rem 2rem", "1rem 2rem 3rem 4rem"
 */
const mapSpacingToPixels = (value) => {
    const s = value
        .trim()
        .split(" ")
        .map((v) => Number(v));
    if (s.some((v) => isNaN(v))) {
        return value;
    }
    return s.map((v) => `${v / 2}rem`).join(" ");
};
exports.mapSpacingToPixels = mapSpacingToPixels;
//# sourceMappingURL=mapSpacingToPixel.js.map